export default __webpack_public_path__ + "static/media/background+pict.64c96319.png";